import { useEffect, useState } from 'react'

import { TextPromo } from 'components/ui'
import { Href } from 'components/ui/Href/Href'
import { Modal } from 'components/uiKit'
import { Flex } from 'components/uiKit/Flex/Flex'
import { useResize } from 'utils/hooks/useResize'
import { URLS } from 'shared/constants/urls'

import CloseIcon from 'assets/icons/crossBlack.svg?react'
import Arrow from 'assets/img/shared/arrow2.svg?react'
import './LimitedOfferSpecialModal.scss'
import s from './LimitedOfferSpecial.module.scss'

export const LimitedOfferSpecial = ({ children }: { children: React.ReactNode }) => {
  const { isTablet, isMobile } = useResize()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const lineHeightModalText = isMobile ? '20px' : '24px'
  const marginTitleText = isMobile ? 12 : 24
  const marginParagraph = isMobile ? 16 : 24

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const getModalTitleSize = () => {
    if (isMobile) {
      return 's20'
    } else if (isTablet) {
      return 's28'
    } else return 's30'
  }

  const getModalTextSize = () => {
    if (isMobile) {
      return 's16'
    } else return 's20'
  }

  const getModalSubtitleSize = () => {
    if (isMobile) {
      return 's16'
    } else return 's24'
  }

  // фикс бага со скролом фоновой страницы под модалкой на афонах
   useEffect(() => {
    if (isModalOpen) {
      const scrollY = window.scrollY
      document.body.style.position = 'fixed'
      document.body.style.top = `-${scrollY}px`
      document.body.style.width = '100%'
      document.body.style.overflow = 'hidden'
      
      return () => {
        document.body.style.position = ''
        document.body.style.top = ''
        document.body.style.overflow = ''
        window.scrollTo(0, scrollY)
      }
    }
  }, [isModalOpen])

  return (
    <Flex vertical className={s.LimitedOffer} gap={isMobile ? 16 : isTablet ? 24 : 32}>
      <Flex className={s.titleWrapper} gap={16} justify="space-between">
        <Flex vertical gap={isMobile ? 8 : isTablet ? 12 : 8}>
          <TextPromo size={isMobile ? 's16' : 's24'} weight="w700" color="white">
            Специальные условия для&nbsp;Северо-Западного федерального округа
          </TextPromo>
          <TextPromo
            fontFamily="ASLHauss"
            size={isMobile ? 's16' : isMobile ? 's20' : 's24'}
            color="white"
            style={{ opacity: 0.8 }}
          >
            Увеличили выплату и добавили новые&nbsp;области
          </TextPromo>
        </Flex>
        <button className={s.button} onClick={handleOpenModal}>
          <Arrow />
        </button>
      </Flex>
      <Flex>{children}</Flex>
      <Modal
        open={isModalOpen}
        onCancel={handleCloseModal}
        footer={null}
        width={'95vw'}
        className={'customModal'}
        closeIcon={<CloseIcon style={{ width: '44px', height: '44px', marginRight: 4 }} />}
        bodyProps={{ style: { maxHeight: '80vh', overflowY: 'scroll' } }}
      >
        <Flex vertical gap={isMobile ? 16 : 24}>
          <Flex vertical gap={marginParagraph}>
            <Flex vertical gap={marginTitleText}>
              <TextPromo
                size={getModalTitleSize()}
                weight={isMobile ? 'w700' : 'w550'}
                fontFamily="ASLHauss"
                style={{ maxWidth: isTablet ? '560px' : '650px' }}
              >
                Специальные условия гарантированного дохода
              </TextPromo>
              <TextPromo
                size={getModalTextSize()}
                weight="w400"
                fontFamily="ASLHaussVF"
                style={{ lineHeight: lineHeightModalText }}
              >
                Мы увеличили сумму финансовой поддержки и добавили гарантированный доход в новых городах. Специальные
                условия будут действовать для заявок на открытие новых пунктов выдачи со 2 июня до 31 июля 2025 года
              </TextPromo>
            </Flex>
            <Flex vertical gap={marginTitleText}>
              <TextPromo size={getModalSubtitleSize()} weight={isMobile ? 'w700' : 'w550'} fontFamily="ASLHauss">
                Что такое гарантированный доход
              </TextPromo>
              <Flex vertical gap={20}>
                <TextPromo
                  size={getModalTextSize()}
                  weight="w400"
                  fontFamily="ASLHaussVF"
                  style={{ lineHeight: lineHeightModalText }}
                >
                  Это финансовая поддержка от Wildberries для новых пунктов выдачи.
                </TextPromo>
                <TextPromo
                  size={getModalTextSize()}
                  weight="w400"
                  fontFamily="ASLHaussVF"
                  style={{ lineHeight: lineHeightModalText }}
                >
                  Если в течение первых 3 месяцев партнёр будет получать доход меньше суммы, которая указана{' '}
                  <Href href={URLS.pick_point_map} type="text" className={s.link} linkType="search" target="_blank">
                    {'на тепловой карте'}
                  </Href>
                  , мы доплатим разницу. Например, гарантированный доход пункта — 200 000 ₽. Если в 1-й месяц
                  пунктзаработает 150 000 ₽, партнёр получит доплату 50 000 ₽
                </TextPromo>
              </Flex>
            </Flex>
            <Flex vertical gap={marginTitleText}>
              <TextPromo size={getModalSubtitleSize()} weight={isMobile ? 'w700' : 'w550'} fontFamily="ASLHauss">
                Какой будет общая сумма выплат за 3 месяца
              </TextPromo>
              <Flex vertical gap={20}>
                <TextPromo
                  size={getModalTextSize()}
                  weight="w400"
                  fontFamily="ASLHaussVF"
                  style={{ lineHeight: lineHeightModalText }}
                >
                  В Санкт-Петербурге — до 960 000 ₽
                </TextPromo>
                <TextPromo
                  size={getModalTextSize()}
                  weight="w400"
                  fontFamily="ASLHaussVF"
                  style={{ lineHeight: lineHeightModalText }}
                >
                  В Ленинградской области — до 675 000 ₽
                </TextPromo>
                <TextPromo
                  size={getModalTextSize()}
                  weight="w400"
                  fontFamily="ASLHaussVF"
                  style={{ lineHeight: lineHeightModalText }}
                >
                  В Республике Коми и Мурманской области — до 555 000 ₽
                </TextPromo>
                <TextPromo
                  size={getModalTextSize()}
                  weight="w400"
                  fontFamily="ASLHaussVF"
                  style={{ lineHeight: lineHeightModalText }}
                >
                  В Архангельской, Калининградской, Новгородской областях и Республике Карелия — до 525 000 ₽
                </TextPromo>
                <TextPromo
                  size={getModalTextSize()}
                  weight="w400"
                  fontFamily="ASLHaussVF"
                  style={{ lineHeight: lineHeightModalText }}
                >
                  В Вологодской и Псковской областях — до 450 000 ₽
                </TextPromo>
                <TextPromo
                  size={getModalTextSize()}
                  weight="w400"
                  fontFamily="ASLHaussVF"
                  style={{ lineHeight: lineHeightModalText }}
                >
                  В Ненецком автономном округе — до 420 000 ₽
                </TextPromo>
              </Flex>
            </Flex>
            <Flex vertical gap={marginTitleText}>
              <TextPromo size={getModalSubtitleSize()} weight={isMobile ? 'w700' : 'w550'} fontFamily="ASLHauss">
                Где посмотреть условия
              </TextPromo>
              <TextPromo
                size={getModalTextSize()}
                weight="w400"
                fontFamily="ASLHaussVF"
                style={{ lineHeight: lineHeightModalText }}
              >
                Точную сумму показываем{' '}
                <Href href={URLS.pick_point_map} type="text" className={s.link} linkType="search" target="_blank">
                  {'на тепловой карте'}
                </Href>
                . Нажмите на зону, где хотите открыть ПВЗ. Сумма будет в окне слева, во вкладке «Поддержка открытия».
                Подробнее об условиях рассказали{' '}
                <Href href={URLS.offer} type="text" className={s.link} linkType="search" target="_blank">
                  в пункте 7.2 оферты
                </Href>
              </TextPromo>
            </Flex>
          </Flex>
        </Flex>
      </Modal>
    </Flex>
  )
}
